<template lang="pug">
//-Header
section.page.full.error
  b-jumbotron(header="401", lead="Unauthorized")
    p 認証エラー
</template>

<script>
export default {
  data () {
    return {
      app: {
        name: process.env.VUE_APP_NAME
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
</style>
